import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { List, ListItem, ListItemText } from '../material-ui/List';
import { Panel } from '../Panel/Panel';
import { ProgressIcon } from '../ProgressIcon/ProgressIcon';
import { AirportServiceSection } from './AirportServiceSection';
import { getTranslateText } from '../../service/utils';
import { useSize } from '../hooks/useSize';
import { MIN_WIDTH_AIRPORT_NAME } from './tools';
import { useAirportServicePage } from './useAirportServicePage';
import { useStyles } from './useStyles';

export const AirportServicePage = memo(() => {
    const { airportServices, allowEdit, allowDelete, currentLeg, noDataMessage, handleDownloadService } = useAirportServicePage();
    const { t: translate } = useTranslation();
    const { width } = useSize();
    const classes = useStyles();

    return (
        <div className={classes.page}>
            <Panel
                icon={<ProgressIcon width="24" height="24" />}
                title={translate('labels.processOperations')}
                onIconClick={handleDownloadService}
            >
                <List subheader={<li />}>
                    {noDataMessage ? (
                        <ListItem>
                            <ListItemText primary={translate(noDataMessage)} />
                        </ListItem>
                    ) : (
                        Object.entries(airportServices).map(([key, item], index) =>
                            item.services.length ? (
                                <AirportServiceSection
                                    key={key}
                                    index={index}
                                    isTakeOff={item.isTakeOff}
                                    title={`${key}${width >= MIN_WIDTH_AIRPORT_NAME ? ` ${getTranslateText('name', item)}` : ''}`}
                                    services={item.services}
                                    legId={currentLeg}
                                    allowEdit={allowEdit}
                                    allowDelete={allowDelete}
                                    classes={classes}
                                />
                            ) : null
                        )
                    )}
                </List>
            </Panel>
        </div>
    );
});

AirportServicePage.displayName = 'AirportServicePage';
